import React from "react";
import {
    Button,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
    Typography,
} from "@material-tailwind/react";

export default function CloneSurveyDialog({ show, handleClose, handleClone }) {
    const handleDialogClose = () => {
        handleClose();
    };

    return (
        <Dialog open={show} handler={handleDialogClose} className="dialog">
            <DialogHeader className="dialog__header">
                <Typography variant="h2">Clone Survey?</Typography>
            </DialogHeader>
            <DialogBody className="dialog__body">
                <div className="dialog__section">
                    <Typography variant="paragraph">
                        This will create a copy of the survey.
                    </Typography>
                </div>
            </DialogBody>
            <DialogFooter className="dialog__footer">
                <Button
                    type="button"
                    className="btn btn--secondary"
                    onClick={handleDialogClose}
                >
                    Cancel
                </Button>
                <Button
                    type="submit"
                    className="btn btn--primary"
                    onClick={handleClone}
                >
                    Clone
                </Button>
            </DialogFooter>
        </Dialog>
    );
}
